import { history } from 'EmailData/utils/history';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DynamicFilterIcon, DeleteIcon } from 'foundations-assets';
import { StatusDot } from 'foundations-components/transitional/components/StatusDot';
import { getEarlyRequestedDefaultViewId } from 'email-management-lib/EarlyRequest/utils';
import { DEFAULT_VIEW_PATH, NAMESPACE } from 'email-management-lib/Shared/constants/frameworkTable';
import { updateQueryParams } from 'email-management-lib/refactor/actions/params';
import IssuesViewTab from 'email-management-lib/refactor/components/manage/frameworkTable/components/IssuesViewTab';
import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * The id of each default view defined in PUMA
 */
const DEFAULT_VIEW_IDS = {
  ALL: '-48',
  DRAFT: '-49',
  SCHEDULED: '-50',
  SENT: '-51',
  ARCHIVED: '-52',
  AI_GENERATED: '-53',
  ISSUES: '-63',
  DELETED: '-64'
};

/**
 * The label of each default view defined in PUMA
 */
const DEFAULT_VIEW_LABELS = {
  ALL: 'all_emails',
  DRAFT: 'draft_emails',
  SCHEDULED: 'scheduled_emails',
  SENT: 'sent_emails',
  ARCHIVED: 'archived_emails',
  AI_GENERATED: 'ai_generated_emails',
  ISSUES: 'issues_emails',
  DELETED: 'deleted_emails'
};

/**
 * Combination of all view id and label for default views
 */

/**
 * All valid view urls
 */

/**
 * Map of view id and labels to view urls
 */
const DefaultViewIdToUrl = {
  [DEFAULT_VIEW_IDS.ALL]: DEFAULT_VIEW_PATH.ALL,
  [DEFAULT_VIEW_LABELS.ALL]: DEFAULT_VIEW_PATH.ALL,
  [DEFAULT_VIEW_IDS.DRAFT]: DEFAULT_VIEW_PATH.DRAFT,
  [DEFAULT_VIEW_LABELS.DRAFT]: DEFAULT_VIEW_PATH.DRAFT,
  [DEFAULT_VIEW_IDS.SCHEDULED]: DEFAULT_VIEW_PATH.SCHEDULED,
  [DEFAULT_VIEW_LABELS.SCHEDULED]: DEFAULT_VIEW_PATH.SCHEDULED,
  [DEFAULT_VIEW_IDS.SENT]: DEFAULT_VIEW_PATH.SENT,
  [DEFAULT_VIEW_LABELS.SENT]: DEFAULT_VIEW_PATH.SENT,
  [DEFAULT_VIEW_IDS.ARCHIVED]: DEFAULT_VIEW_PATH.ARCHIVED,
  [DEFAULT_VIEW_LABELS.ARCHIVED]: DEFAULT_VIEW_PATH.ARCHIVED,
  [DEFAULT_VIEW_IDS.AI_GENERATED]: DEFAULT_VIEW_PATH.AI_GENERATED,
  [DEFAULT_VIEW_LABELS.AI_GENERATED]: DEFAULT_VIEW_PATH.AI_GENERATED,
  [DEFAULT_VIEW_IDS.ISSUES]: DEFAULT_VIEW_PATH.ISSUES,
  [DEFAULT_VIEW_LABELS.ISSUES]: DEFAULT_VIEW_PATH.ISSUES,
  [DEFAULT_VIEW_IDS.DELETED]: DEFAULT_VIEW_PATH.DELETED,
  [DEFAULT_VIEW_LABELS.DELETED]: DEFAULT_VIEW_PATH.DELETED
};

/**
 * Map of view urls to view ids
 */
const ViewUrlToViewId = {
  [DEFAULT_VIEW_PATH.ALL]: DEFAULT_VIEW_IDS.ALL,
  [DEFAULT_VIEW_PATH.DRAFT]: DEFAULT_VIEW_IDS.DRAFT,
  [DEFAULT_VIEW_PATH.SCHEDULED]: DEFAULT_VIEW_IDS.SCHEDULED,
  [DEFAULT_VIEW_PATH.SENT]: DEFAULT_VIEW_IDS.SENT,
  [DEFAULT_VIEW_PATH.ARCHIVED]: DEFAULT_VIEW_IDS.ARCHIVED,
  [DEFAULT_VIEW_PATH.AI_GENERATED]: DEFAULT_VIEW_IDS.AI_GENERATED,
  [DEFAULT_VIEW_PATH.ISSUES]: DEFAULT_VIEW_IDS.ISSUES,
  [DEFAULT_VIEW_PATH.DELETED]: DEFAULT_VIEW_IDS.DELETED
};
const renderDraftEmailsViewTab = () => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(StatusDot, {
    use: "draft"
  }), /*#__PURE__*/_jsx(FormattedMessage, {
    message: "email-management.sendStates.draft"
  })]
});
const renderScheduledEmailsViewTab = () => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(StatusDot, {
    use: "scheduled"
  }), /*#__PURE__*/_jsx(FormattedMessage, {
    message: "email-management.sendStates.scheduled"
  })]
});
const renderSentEmailsViewTab = () => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(StatusDot, {
    use: "sent"
  }), /*#__PURE__*/_jsx(FormattedMessage, {
    message: "email-management.sendStates.sent"
  })]
});
const renderArchivedEmailsViewTab = () => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(StatusDot, {
    hollow: true,
    use: "default"
  }), /*#__PURE__*/_jsx(FormattedMessage, {
    message: "email-management.sendStates.archived"
  })]
});
const renderAiGeneratedViewTab = () => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(DynamicFilterIcon, {
    color: "do-not-use-eerie",
    size: "300"
  }), /*#__PURE__*/_jsx(FormattedMessage, {
    message: "email-management.sendStates.ai"
  })]
});
const renderDeletedViewTab = () => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(DeleteIcon, {
    color: "do-not-use-eerie",
    size: "300"
  }), /*#__PURE__*/_jsx(FormattedMessage, {
    message: "email-management.sendStates.deleted"
  })]
});
const DefaultViewToCustomTab = {
  [DEFAULT_VIEW_IDS.ALL]: undefined,
  [DEFAULT_VIEW_LABELS.ALL]: undefined,
  [DEFAULT_VIEW_IDS.DRAFT]: renderDraftEmailsViewTab,
  [DEFAULT_VIEW_LABELS.DRAFT]: renderDraftEmailsViewTab,
  [DEFAULT_VIEW_IDS.SCHEDULED]: renderScheduledEmailsViewTab,
  [DEFAULT_VIEW_LABELS.SCHEDULED]: renderScheduledEmailsViewTab,
  [DEFAULT_VIEW_IDS.SENT]: renderSentEmailsViewTab,
  [DEFAULT_VIEW_LABELS.SENT]: renderSentEmailsViewTab,
  [DEFAULT_VIEW_IDS.ARCHIVED]: renderArchivedEmailsViewTab,
  [DEFAULT_VIEW_LABELS.ARCHIVED]: renderArchivedEmailsViewTab,
  [DEFAULT_VIEW_IDS.AI_GENERATED]: renderAiGeneratedViewTab,
  [DEFAULT_VIEW_LABELS.AI_GENERATED]: renderAiGeneratedViewTab,
  [DEFAULT_VIEW_IDS.DELETED]: renderDeletedViewTab,
  [DEFAULT_VIEW_LABELS.DELETED]: renderDeletedViewTab,
  [DEFAULT_VIEW_IDS.ISSUES]: view => IssuesViewTab({
    view
  }),
  [DEFAULT_VIEW_LABELS.ISSUES]: view => IssuesViewTab({
    view
  })
};
export const isDefaultViewId = viewId => Object.keys(DefaultViewIdToUrl).includes(viewId);
export const isDefaultViewUrl = viewUrl => Object.keys(ViewUrlToViewId).includes(viewUrl);
export const viewIdToUrl = viewIdString => isDefaultViewId(viewIdString) ? DefaultViewIdToUrl[viewIdString] : viewIdString;
const urlToViewId = viewIdUrl => viewIdUrl && isDefaultViewUrl(viewIdUrl) ? ViewUrlToViewId[viewIdUrl] : viewIdUrl;
const getEmailViewsDetailsUrl = state => `/manage/state/${state}`;
export default function useEmailViewProps() {
  const dispatch = useDispatch();
  const {
    state
  } = useParams();
  const location = useLocation();
  const lastPath = location.pathname.split('/').pop();

  /**
   * An undefined currentViewId means it was not specified via URL,
   * meaning the accessed route is one of the following:
   * - /email/{portalId}
   * - /email/{portalId}/manage
   * - /email/{portalId}/manage/state
   * In this scenario, we will not default currentViewId to the leftmost view,
   * even though it has already been early requested
   * because it will cause a rerender and make early requested data lost
   * the redirect will be handled by the useEffect below
   */
  const currentViewId = useMemo(() => {
    return urlToViewId(state);
  }, [state]);
  const handleViewIdChange = useCallback((viewId, options = {}) => {
    if (['whitelisting', 'limits'].includes(lastPath)) {
      return;
    }
    const _state = viewIdToUrl(viewId);
    const url = getEmailViewsDetailsUrl(_state);
    if (options.redirect) {
      history.replace(url);
    } else {
      history.push(url);
    }
    dispatch(updateQueryParams({}));
  }, [dispatch, lastPath]);
  const viewIdFromEarlyRequest = getEarlyRequestedDefaultViewId();
  useEffect(() => {
    if (viewIdFromEarlyRequest && !currentViewId) {
      // Since we're manually setting the view from quickFetch,
      // we need to manually trigger the route change
      handleViewIdChange(viewIdFromEarlyRequest, {
        redirect: true
      });
    }
  }, [currentViewId, handleViewIdChange, viewIdFromEarlyRequest]);
  const renderTab = useCallback(view => {
    const maybeRenderTab = DefaultViewToCustomTab[view.id];
    if (maybeRenderTab) {
      return maybeRenderTab(view);
    }
    return null;
  }, []);
  return useMemo(() => ({
    currentViewId: currentViewId && String(currentViewId),
    hasViews: true,
    namespace: NAMESPACE,
    onViewIdChange: handleViewIdChange,
    renderTab
  }), [currentViewId, handleViewIdChange, renderTab]);
}